import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/style.css";
import "./css/helpers.css";

ReactDOM.render(<App />, document.getElementById("root"));
